import { Controller } from '@hotwired/stimulus'

function csrfToken() {
  return document.querySelector('meta[name=csrf-token]')?.content
}

export default class extends Controller {
  static values = { uncompleteUrl: String, activeUrl: String }

  async reopen() {
    try {
      const resp = await fetch(this.uncompleteUrlValue, {
        method: 'PATCH',
        headers: { 'X-CSRF-Token': csrfToken() },
      })
      if (!resp.ok) throw new Error(`PATCH failed: ${resp.status}`)

      window.location.href = this.activeUrlValue
    } catch (err) {
      console.error('Reopen failed:', err)
    }
  }
}
